export default [
    {
        path: '/jobrad/bidex-categories',
        name: 'jobrad_bidex_categories',
        component: () => import('@src/jobrad/jobrad-bidex-categories.vue'),
        meta: {
            title: 'BIDEX-Kategorien',
            role: 'ROLE_BIDEX_CATEGORIES',
        },
    },
];
